export const dpWdStatsTheme = {
  barValuesText: 'palette.tertiary.60',
  depositBar: 'palette.success.40',
  stroke: 'palette.tertiary.10',
  withdrawalBar: 'palette.error.40',
};
